import React, { useState } from 'react';
import Sheet from './ui/Sheet';
import { WarningIcon } from './ui/icons';
import './AbandonSheet.css';

interface StartFailedSheetProps {
  isOpen: boolean;
  onRetry: () => Promise<void>;
  onClose: () => void;
}

/**
 * A first scan with no signal. Later scans queue against the crawl, but the
 * first one has no crawl to queue against until the server creates it, so
 * this one blocks and asks the player to retry.
 */
const StartFailedSheet: React.FC<StartFailedSheetProps> = ({ isOpen, onRetry, onClose }) => {
  const [retrying, setRetrying] = useState(false);

  const handleRetry = async () => {
    setRetrying(true);
    try {
      await onRetry();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <Sheet isOpen={isOpen} onClose={onClose} title="No signal" testId="start-failed-sheet">
      <div className="abandon-sheet-warning">
        <WarningIcon />
        <p>
          We couldn't start your crawl. <b>Your first scan needs a connection.</b> Find a
          bit of signal, then try again. Scans after this one are saved even when you're offline.
        </p>
      </div>
      <button
        className="abandon-sheet-primary"
        onClick={handleRetry}
        disabled={retrying}
        data-testid="start-retry"
      >
        {retrying ? 'Trying…' : 'Try again'}
      </button>
    </Sheet>
  );
};

export default StartFailedSheet;
